import React from 'react';

interface SideMenuProps {
  open: boolean;
  onClose: () => void;
}

/**
 * SideMenu - A global slide-out menu for navigation and quick actions.
 *
 * Props:
 *   open: boolean - Whether the menu is visible.
 *   onClose: () => void - Handler to close the menu.
 */
const SideMenu: React.FC<SideMenuProps> = ({ open, onClose }) => {
  // Don't render the menu at all when it's closed to prevent accessibility issues
  if (!open) {
    return null;
  }

  return (
    <div 
      className="side-menu-overlay open" 
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Main navigation menu"
    >
      <nav
        className="side-menu open"
        onClick={e => e.stopPropagation()}
        aria-label="Main menu"
      >
        <button 
          className="side-menu-close" 
          onClick={onClose} 
          aria-label="Close menu"
          aria-expanded={true}
        >
          <span style={{ fontSize: 40, lineHeight: 1, color: '#fff' }} aria-hidden="true">&times;</span>
        </button>
        <ul className="side-menu-list" role="menubar">
          <li role="none">
            <a 
              href="https://mindfultherapygroup.com/find-a-provider/" 
              className="side-menu-link"
              role="menuitem"
              aria-label="Find a provider"
            >
              Find A Provider
            </a>
          </li>
          <li role="none">
            <a 
              href="https://mindfultherapygroup.com/locations/" 
              className="side-menu-link"
              role="menuitem"
              aria-label="View locations"
            >
              Locations
            </a>
          </li>
          <li className="side-menu-link-group" role="none">
            <span 
              className="side-menu-link"
              role="menuitem"
              aria-label="Client resources"
            >
              Client Resources
            </span>
            <span className="side-menu-arrow" aria-hidden="true">&#8594;</span>
          </li>
          <li className="side-menu-link-group" role="none">
            <span 
              className="side-menu-link"
              role="menuitem"
              aria-label="For providers"
            >
              For Providers
            </span>
            <span className="side-menu-arrow" aria-hidden="true">&#8594;</span>
          </li>
        </ul>
        <div style={{ margin: '32px 0 0 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <button 
            className="side-menu-portal-btn"
            aria-label="Access patient portal"
          >
            Patient Portal
          </button>
          <button 
            className="side-menu-get-started-btn"
            aria-label="Get started with services"
          >
            GET STARTED <span className="side-menu-arrow" aria-hidden="true">&#8594;</span>
          </button>
        </div>
      </nav>
    </div>
  );
};

export default SideMenu; 